<template>
  <card-modal>
    <template
      slot="content"
      class="qr-wrapper"
    >
      <img :src="`data:image/png;base64,${qr}`">
    </template>
  </card-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import CardModal from '../../common/CardModal'

import store from '../../state'

export default {
  components: {
    CardModal
  },
  props: {
    serialNumber: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'getBridgeQr'
    ]),
    qr() {
      return this.getBridgeQr(this.serialNumber)
    }
  },
  created() {
    this.$store = store
  },
  methods: {

  }
}
</script>

<style>
.qr-modal .card-content-md {
  display: flex;
  height:100%;
  align-content: center;
  justify-content: center;
}

.qr-modal .card-content-md img {
  height:100%;
}
</style>